import { CloudUpload } from "lucide-react";
import { useStillSending } from "../hooks/use-outbox";
import { cn } from "../lib/utils";

/**
 * A small "Šalje se…" next to a post or comment the server hasn't confirmed
 * yet (e.g. written without internet). It goes away by itself once it's sent.
 */
export function StillSending({ path, className }: { path: string; className?: string }) {
  const sending = useStillSending(path);
  if (!sending) return null;
  return (
    <span
      className={cn("inline-flex items-center gap-1 text-xs text-muted-foreground", className)}
      title="Poslat će se sama čim bude interneta"
      role="status"
    >
      <CloudUpload className="h-3 w-3 animate-pulse" />
      Šalje se…
    </span>
  );
}
